
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resize-png",
      function () {
        return require("private-next-pages/resize-png/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resize-png"])
      });
    }
  